import * as React from 'react'

import { Grid } from 'components/Grid'
import Icon from 'components/Icon'

import './InfoBox.scss'

interface InfoBoxItemProps {
  icon: JSX.Element
  firstLine: string | JSX.Element
  secondLine?: string | JSX.Element
  iconProps?: object
}

interface InfoBoxProps {
  children: any[]
}

const InfoBoxItem: React.FC<InfoBoxItemProps> = props => {
  return (
    <div className="srprs-infoBox-item">
      <Icon icon={props.icon} {...props?.iconProps} />
      {props.firstLine && props.secondLine ? (
        <div className="infoBox-aside">
          <span>{props.firstLine}</span>
          <span>{props.secondLine}</span>
        </div>
      ) : (
        <div className="infoBox-aside-oneline">
          <span>{props.firstLine}</span>
        </div>
      )}
    </div>
  )
}

const InfoBox: React.FC<InfoBoxProps> = props => {
  return (
    <div className="srprs-infoBox">
      <Grid nrCols={[props.children.length]} slider>
        {props.children}
      </Grid>
    </div>
  )
}

export { InfoBox, InfoBoxItem }
